/*
 * @Description: http请求工具
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-04-15 15:48:48
 * @LastEditTime: 2021-03-15 16:55:19
 */

import qs from 'query-string'

// const _fetch = async (url, option) => {
  
//   const res = await fetch(url, option)

//   if (res.status === 404) {
//     return alert('404，获取数据失败！');
//   }

//   return res.json()
// };

/**
 * 根据type返回不同格式的response
 */
var _returnContentByType = (response, blob) => {
  const contentType = response.headers.get('Content-Type')
  const type = contentType ? contentType.split(";")[0] : contentType
  if (blob) return response.blob()
	switch (type) {
    case 'text/html':
      return response.text();
    case 'application/json':
      return response.json();
    default:
      return response.text();
  }
}



const _fetch = (url, option) => {
  return new Promise((resolve, rejcet) => {
    const {blob, ..._option} = option
    fetch(url, _option)
      .then(res => {
        // console.log(res)
        // console.log(res.headers.get('Content-Type'));
        if (res.status === 302 || res.status === 404 || res.status === 500) {
          console.info(`${res.status}:${res.statusText}`)
        } else {
          return _returnContentByType(res, blob)
        }
        return null
      })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        console.log('数据请求失败');
        rejcet(err)
      })
  })
}

const http = {
  Get (url, data = {}, option = {}) {
    return _fetch(`${url}?${qs.stringify(data)}`, Object.assign({
      method: 'GET',
      cache: 'no-cache',
      credentials: 'include'
    }, option));
  },

  Post (url, data = {}, option = {}) {
    let query = data instanceof FormData ? data : JSON.stringify(data)
    return _fetch(url, Object.assign({
      method: 'POST',
      cache: 'no-cache',
      credentials: 'include',
      body: query
    }, option));
  }
};

export default http



// WEBPACK FOOTER //
// src/controller/http.js